import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';
import { DateFieldPolyfillInput } from './DateFieldPolyfill';

import { isDateFieldSupported } from '$Utils';

/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
const DateFieldInput = props => {
    const {
        disabled,
        id,
        inputClassName,
        name,
        onChange,
        onFocus,
        onBlur,
        pattern,
        placeholder,
        required,
        value
    } = props;

    if (!isDateFieldSupported()) {
        return <DateFieldPolyfillInput {...props} />;
    }
    return (
        <input
            disabled={disabled}
            id={id || name}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            onFocus={onFocus}
            placeholder={placeholder || 'MM/DD/YYYY'}
            required={required}
            className={styles[inputClassName]}
            type="date"
            value={value || ''}
            data-tc="real"
        />
    );
};
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export default FieldWrapper(DateFieldInput, { reduxForm: true });
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export const DateField = FieldWrapper(DateFieldInput);
